import { render, staticRenderFns } from "./EventModalStandFields.vue?vue&type=template&id=225342e5&scoped=true"
import script from "./EventModalStandFields.vue?vue&type=script&lang=js"
export * from "./EventModalStandFields.vue?vue&type=script&lang=js"
import style0 from "./EventModalStandFields.vue?vue&type=style&index=0&id=225342e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225342e5",
  null
  
)

export default component.exports